/* eslint-disable react/no-unused-prop-types */
import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loading from 'react/components/Loading';

const signatureContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '8px'
};

const signatureImgStyle = {
  backgroundColor: '#fff',
  width: '50%',
  height: '50%'
};

const copyIconStyle = {
  cursor: 'pointer',
  marginLeft: '5px',
  position: 'relative',
  top: '2px'
};

const successIconStyle = {
  marginLeft: '5px'
};

const SignatureHash = ({ hash }) => {
  const label = `${Monet.I18n.getResourcesByKey('Signature.hashCode')}: `;
  const [showCopySuccess, setShowCopySuccess] = useState(false);

  const textHash = useMemo(() => {
    const hashLength = label.length + hash.length;
    const hasOverflowContent = hashLength > 35;
    const formattedHash = `${hash.substr(0, 30)}...${hash.substr(hash.length - 4, hash.length)}`;

    return hasOverflowContent ? formattedHash : hash;
  }, [hash]);

  if (!hash) {
    return null;
  }

  return (
    <div style={{ width: 'fit-content', margin: 'auto' }}>
      {label}
      {textHash}
      <div
        onClick={() => {
          navigator.clipboard.writeText(hash);
          setShowCopySuccess(true);
          setTimeout(() => setShowCopySuccess(false), 1500);
        }}
        className={`icon copy gray ${showCopySuccess ? 'hide' : ''}`}
        style={copyIconStyle}
      />
      <object
        type="image/svg+xml"
        data="/static/images/animated-check-gray.svg"
        aria-label="success"
        className={`icon ${showCopySuccess ? '' : 'hide'}`}
        style={successIconStyle}
      />
    </div>
  );
};

const Signature = (props) => {
  const {
    signatureImageAsBase64, isLoadingSignature, signatureAltText, signatureHash
  } = props;
  const imgSrc = `data:image/jpeg;base64,${signatureImageAsBase64}`;
  return (
    <div style={signatureContainerStyle}>
      {
        isLoadingSignature ? (
          <Loading />
        ) : (
          <div style={{ width: '100%', textAlign: 'center' }}>
            <img src={imgSrc} alt={signatureAltText} style={signatureImgStyle} />
            <SignatureHash hash={signatureHash} />
          </div>
        )
      }
    </div>
  );
};

Signature.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoadingSignature: PropTypes.bool.isRequired,
  signatureImageAsBase64: PropTypes.string.isRequired,
  signatureAltText: PropTypes.string,
  signatureHash: PropTypes.string.isRequired
};

Signature.defaultProps = {
  signatureAltText: ''
};

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  signatureImageAsBase64: stopDetailsPopup.getIn(['signature', String(routeId), String(stopId), 'signature', 'signatureImageAsBase64'], ''),
  isLoadingSignature: stopDetailsPopup.getIn(['signature', String(routeId), String(stopId), 'isLoadingSignature'], true),
  signatureAltText: stopDetailsPopup.getIn(['signature', String(routeId), String(stopId), 'signature', 'stopSignature', 'name'], ''),
  signatureHash: stopDetailsPopup.getIn(['signature', String(routeId), String(stopId), 'signature', 'stopSignature', 'hashCode'], '')
});

export default connect(mapStateToProps, null)(Signature);
